export const renameLastItem = (
  path: string,
  replacer: (v: string) => string,
  seperator = '/'
): string => {
  const pathArray = path.split(seperator)
  const index = pathArray.length - 1
  pathArray[index] = replacer(pathArray[index])
  return pathArray.join(seperator)
}

export const getStorageUrlSize = (
  url: string,
  width: string | number,
  height?: string | number
) => {
  const urlObj = new URL(url)

  if (!height) height = width

  return (
    urlObj.origin +
    renameLastItem(
      renameLastItem(urlObj.pathname, (v) => v),
      (s: string) => `${s}_${width}x${height}`
    ) +
    urlObj.search
  )
}

export const getStoragePathSize = (
  path: string,
  width: string | number,
  height?: string | number
) => {
  if (!height) height = width

  return renameLastItem(path, (s: string) => `${s}_${width}x${height}`)
}
